angular.module('impactx.product').controller('ProductPrgCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'currentPrg',
    'catId',
    'vcatId',
    ProductPrgCtrl]);

function ProductPrgCtrl($scope, $mdDialog, themeFactory, dataGen, currentPrg, catId, vcatId) {
    var ctrl = this;
    $scope.currentPrg = currentPrg;
    $scope.catId = catId;
    $scope.vcatId = vcatId;
    var openPrgIds = [];

    dataGen.getData($scope, {catId: catId, vcatId: vcatId}, "/product/checkout/edit/prg");

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.confirm = function () {
        $mdDialog.hide($scope.selectedPrg);
    };

    this.validSelected = function () {
        return $scope.selectedPrg && $scope.selectedPrg.id > 0 && (!$scope.selectedPrg.subProductGroups || $scope.selectedPrg.subProductGroups.length === 0);
    };

    this.toggle = function (event, entry) {
        event.stopPropagation();
        event.preventDefault();
        if (entry.isOpen) {
            var index = openPrgIds.indexOf(entry.id);
            if (index >= 0) {
                openPrgIds.splice(index, 1);
            }
        }
        else {
            entry.priceRuleDataOfSubGroupsSet = true;
            openPrgIds.push(entry.id);
        }
        entry.isOpen = !entry.isOpen;

        if(!entry.subProductGroups || entry.subProductGroups.length === 0) {
            if($scope.selectedPrg) {
                $scope.selectedPrg.isSelected = false;
            }
            $scope.selectedPrg = entry;
            $scope.selectedPrg.isSelected = true;
        }
    };

}